import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=deab87ca&scoped=true"
import script from "./UiCard.vue?vue&type=script&lang=js"
export * from "./UiCard.vue?vue&type=script&lang=js"
import style0 from "./UiCard.vue?vue&type=style&index=0&id=deab87ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deab87ca",
  null
  
)

export default component.exports